import { regexps } from "@/utilles/validator/regexps";

export function testRegexp(regexpName, value) {
  return regexps[regexpName]?.test(value);
}
